import { variables
 } from "politicamente-informados-ds";
import styled, { keyframes } from "styled-components";

interface IFeedbackContainerProps {
  collapsed: boolean;
}

interface IFeedbackWrapperProps {
  $hidden: boolean;
}

const fadeInOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
export const FeedbackWrapper = styled.div<IFeedbackWrapperProps>`
  max-height: 70dvh;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 20px;
  z-index: 50;
  pointer-events: none;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  animation: ${({ $hidden }) => ($hidden ? fadeInOut : 'none')} 2s ease;


  ::-webkit-scrollbar {
    display: none;
}

`;

export const FeedbackContainer = styled.div<IFeedbackContainerProps>`
  background-color: black;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 100%;
  max-width: 400px;
  padding: 0;
  pointer-events: all;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  color: ${variables.colors.primary70};
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: white;
  padding: 15px 20px;
  font-size: 30px;
  overflow: auto;
`;


export interface ICollapsed {
  collapsed: boolean;
}

export const CollapsibleContent = styled.div<ICollapsed>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  list-style: none;
  padding: 0;
  max-height: ${({ collapsed }) => (collapsed ? "0" : "70vh")};
  overflow: auto;
  transition: max-height 0.3s ease;

`;

export const CollapseIcon = styled.svg<ICollapsed>`
  transform: rotate(${({ collapsed }) => (collapsed ? "180deg" : "0deg")});
  transition: transform 0.3s ease;
width:25px;
height:25px;
overflow: auto;
`;

export const Success = styled.div`
  display: grid;
  place-items: center;
  padding: 10px 20px;
  background-color: white;
`;

export const Error = styled.div`
  display: grid;
  place-items: center;
  gap:16px;
  padding: 10px 20px;
`;

export const StyledQuestions = styled.div`
  display: grid;
  gap: 10px;
  padding: 15px 20px;
  overflow-y: scroll;
  background-color: white;
`;

export const StyledQuestion = styled.div`
  display: grid;
  /* gap: 16px; */
  place-items: center center;

  textarea {
    font-family: "Poppins";
    font-size: ${variables.pxToRem(16)};
    padding: 1rem;
    border: 1px solid ${variables.colors.primary70};
    border-radius: 4px;
  }
`;

export const StyledContentIntro = styled.div`
  padding: 0px 20px 15px 20px;
  color: white;
  width: 100%;
`;